import React, { createContext, useState, useContext, useRef } from "react";
import { ViewContext } from "venuescanner-js/react/components/Inbox/context/ViewContext";

export const MessageInputContext = createContext({
  messageInputText: null,
  attached: null,
  setAttached: null,
  clear: null,
  toggleInput: null,
  loadMessage: null,
  errorMessage: null,
  setErrorMessage: null,
});

const MessageInputProvider = ({ children }) => {
  const messageInputText = useRef();
  const [attached, setAttached] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const { setIsUserTyping } = useContext(ViewContext);
  const clear = () => {
    messageInputText.current.innerHTML = "";
    setIsUserTyping(false);
    setAttached([]);
  };
  const toggleInput = (bool) => {
    setIsUserTyping(bool);
    if (bool) messageInputText.current.focus();
  };

  const loadMessage = ({ content, attachments }) => {
    setTimeout(() => {
      messageInputText.current.innerHTML = content;
      setAttached(attachments);
      toggleInput(true);
    });
  };

  return (
    <>
      <MessageInputContext.Provider
        value={{
          clear,
          toggleInput,
          messageInputText,
          attached,
          setAttached,
          loadMessage,
          errorMessage,
          setErrorMessage,
        }}
      >
        {children}
      </MessageInputContext.Provider>
    </>
  );
};

export default MessageInputProvider;
